import { ChainId, ERC20Token } from '@donaswap/sdk'
import { bscTestnetTokens, bscTokens, ethereumTokens, goerliTestnetTokens } from '@donaswap/tokens'
import type { CommonPrice } from '../../src/fetchFarmsV3'
import type { FarmSupportedChainId } from '../../src'

export const CAKE_BNB_LP_MAINNET = '0x0eD7e52944161450477ee417DE9Cd3a859b14fD0'

export type PriceHelper = {
  chain: string
  list: ERC20Token[]
}

export const CHAIN_ID_TO_CHAIN_NAME = {
  [ChainId.FIRECHAIN]: 'firechain',
  [ChainId.RINIA]: 'firechain',
  [ChainId.BSC]: 'bsc',
  [ChainId.BSC_TESTNET]: 'bsc',
  [ChainId.ETHEREUM]: 'ethereum',
  [ChainId.GOERLI]: 'ethereum',
  [ChainId.SEPOLIA]: 'ethereum',
  
  [ChainId.POLYGON]: '',
  [ChainId.POLYGON_MUMBAI]: '',
  [ChainId.POLYGON_ZKEVM]: '',
  [ChainId.POLYGON_ZKEVM_TESTNET]: '',
  [ChainId.CRO]: '',
  [ChainId.CRO_TESTNET]: '',
  [ChainId.AVALANCHE]: '',
  [ChainId.AVALANCHE_FUJI]: '',
  [ChainId.FANTOM_OPERA]: '',
  [ChainId.FANTOM_TESTNET]: '',
  [ChainId.CELO]: '',
  [ChainId.CELO_ALFAJORES]: '',
  [ChainId.OPTIMISM]: '',
  [ChainId.OPTIMISM_GOERLI]: '',
  [ChainId.ARBITRUM_ONE]: '',
  [ChainId.ARBITRUM_GOERLI]: '',
  [ChainId.SHIBARIUM]: '',
  [ChainId.SHIBARIUM_TESTNET]: '',
  [ChainId.PULSECHAIN]: '',
  [ChainId.PULSECHAIN_TESTNET]: '',
  [ChainId.XEN]: '',
  [ChainId.XEN_DEVNET]: '',
  [ChainId.HARMONY]: '',
  [ChainId.HARMONY_TESTNET]: '',
  [ChainId.COINEX]: '',
  [ChainId.COINEX_TESTNET]: '',
  [ChainId.DOGECHAIN]: '',
  [ChainId.DOGECHAIN_TESTNET]: '',
  [ChainId.ETHEREUM_CLASSIC]: '',
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: '',
  [ChainId.FUSION]: '',
  [ChainId.FUSION_TESTNET]: '',
  [ChainId.HECO]: '',
  [ChainId.HECO_TESTNET]: '',
  [ChainId.KCC]: '',
  [ChainId.KCC_TESTNET]: '',
  [ChainId.KLAYTN]: '',
  [ChainId.KLAYTN_BAOBAB]: '',
  [ChainId.OKXCHAIN]: '',
  [ChainId.OKXCHAIN_TESTNET]: '',
  [ChainId.THETHA]: '',
  [ChainId.THETHA_TESTNET]: '',
  [ChainId.ULTRON]: '',
  [ChainId.ULTRON_TESTNET]: '',
  [ChainId.MOONBEAM]: '',
  [ChainId.MOONRIVER]: '',
  [ChainId.MOONBASE_ALPHA]: '',
  [ChainId.AURORA]: '',
  [ChainId.AURORA_TESTNET]: '',
  [ChainId.BOBA]: '',
  [ChainId.BOBA_GOERLI]: '',
  [ChainId.GNOSIS]: '',
  [ChainId.GNOSIS_CHIADO]: '',
  [ChainId.METIS]: '',
  [ChainId.METIS_GOERLI]: '',
  [ChainId.TELOS]: '',
  [ChainId.TELOS_TESTNET]: '',
  [ChainId.SYSCOIN]: '',
  [ChainId.SYSCOIN_TANENBAUM]: '',
  [ChainId.IOTEX]: '',
  [ChainId.IOTEX_TESTNET]: '',
  [ChainId.SHIDEN]: '',
  [ChainId.ASTAR]: '',
  [ChainId.SHIBUNYA]: '',
  [ChainId.FUSE]: '',
  [ChainId.FUSE_SPARKNET]: '',
  [ChainId.VELAS]: '',
  [ChainId.VELAS_TESTNET]: '',
  [ChainId.REI]: '',
  [ChainId.REI_TESTNET]: '',
  [ChainId.KEKCHAIN]: '',
  [ChainId.KEKCHAIN_TESTNET]: '',
  [ChainId.TOMOCHAIN]: '',
  [ChainId.TOMOCHAIN_TESTNET]: '',
  [ChainId.THUNDERCORE]: '',
  [ChainId.THUNDERCORE_TESTNET]: '',
  [ChainId.WANCHAIN]: '',
  [ChainId.WANCHAIN_TESTNET]: '',
  [ChainId.RSK]: '',
  [ChainId.RSK_TESTNET]: '',
  [ChainId.ELASTOS]: '',
  [ChainId.ELASTOS_TESTNET]: '',
  [ChainId.CONFLUX]: '',
  [ChainId.CONFLUX_TESTNET]: '',
  [ChainId.BRISECHAIN]: '',
  [ChainId.BRISECHAIN_TESTNET]: '',
  [ChainId.MUUCHAIN]: '',
  [ChainId.MUUCHAIN_TESTNET]: '',
  [ChainId.CANTO]: '',
  [ChainId.CANTO_TESTNET]: '',
  [ChainId.OASIS_EMERALD]: '',
  [ChainId.OASIS_TESTNET]: '',
  [ChainId.VISION]: '',
  [ChainId.VISION_TESTNET]: '',
  [ChainId.STEP]: '',
  [ChainId.STEP_TESTNET]: '',
  [ChainId.METER]: '',
  [ChainId.METER_TESTNET]: '',
  [ChainId.GODWOKEN]: '',
  [ChainId.GODWOKEN_TESTNET]: '',
  [ChainId.CALLISTO]: '',
  [ChainId.CALLISTO_TESTNET]: '',
  [ChainId.EVMOS]: '',
  [ChainId.EVMOS_TESTNET]: '',
  [ChainId.ENERGY_WEB_CHAIN]: '',
  [ChainId.ENERGY_VOLTA]: '',
  [ChainId.BASE]: '',
  [ChainId.BASE_GOERLI]: '',
  [ChainId.KAVA]: '',
  [ChainId.KAVA_TESTNET]: '',
  [ChainId.CLOVER]: '',
  [ChainId.CLOVER_TESTNET]: '',
  [ChainId.DEFICHAIN]: '',
  [ChainId.DEFICHAIN_TESTNET]: '',
  [ChainId.BRONOS]: '',
  [ChainId.BRONOS_TESTNET]: '',
  [ChainId.FILECOIN]: '',
  [ChainId.FILECOIN_CALIBRATION]: '',
  [ChainId.FLARE]: '',
  [ChainId.FLARE_TESTNET]: '',
  [ChainId.TARAXA]: '',
  [ChainId.TARAXA_TESTNET]: '',
  [ChainId.ZKSYNC]: '',
  [ChainId.ZKSYNC_TESTNET]: '',
  [ChainId.LINEA_TESTNET]: '',
} satisfies Record<FarmSupportedChainId, string>

export const priceHelperTokens = {
  [ChainId.ETHEREUM]: {
    chain: 'ethereum',
    list: [ethereumTokens.weth,
      ethereumTokens.usdc,
      ethereumTokens.usdt],
  },
  [ChainId.BSC]: {
    chain: 'bsc',
    list: [bscTokens.wbnb, bscTokens.usdt, bscTokens.busd, bscTokens.eth],
  },
} satisfies Record<number, PriceHelper>

// for testing purposes
export const DEFAULT_COMMON_PRICE: Record<FarmSupportedChainId, CommonPrice> = {
  [ChainId.FIRECHAIN]: {},
  [ChainId.RINIA]: {},
  [ChainId.ETHEREUM]: {},
  [ChainId.GOERLI]: {
    [goerliTestnetTokens.mockA.address]: '10',
  },
  [ChainId.SEPOLIA]: {},
  [ChainId.BSC]: {},
  [ChainId.BSC_TESTNET]: {
    [bscTestnetTokens.mockA.address]: '10',
    [bscTestnetTokens.usdt.address]: '1',
    [bscTestnetTokens.busd.address]: '1',
    [bscTestnetTokens.usdc.address]: '1',
  },
  [ChainId.POLYGON]: {},
  [ChainId.POLYGON_MUMBAI]: {},
  [ChainId.POLYGON_ZKEVM]: {},
  [ChainId.POLYGON_ZKEVM_TESTNET]: {},
  [ChainId.CRO]: {},
  [ChainId.CRO_TESTNET]: {},
  [ChainId.AVALANCHE]: {},
  [ChainId.AVALANCHE_FUJI]: {},
  [ChainId.FANTOM_OPERA]: {},
  [ChainId.FANTOM_TESTNET]: {},
  [ChainId.CELO]: {},
  [ChainId.CELO_ALFAJORES]: {},
  [ChainId.OPTIMISM]: {},
  [ChainId.OPTIMISM_GOERLI]: {},
  [ChainId.ARBITRUM_ONE]: {},
  [ChainId.ARBITRUM_GOERLI]: {},
  [ChainId.SHIBARIUM]: {},
  [ChainId.SHIBARIUM_TESTNET]: {},
  [ChainId.PULSECHAIN]: {},
  [ChainId.PULSECHAIN_TESTNET]: {},
  [ChainId.XEN]: {},
  [ChainId.XEN_DEVNET]: {},
  [ChainId.HARMONY]: {},
  [ChainId.HARMONY_TESTNET]: {},
  [ChainId.COINEX_TESTNET]: {},
  [ChainId.COINEX]: {},
  [ChainId.DOGECHAIN]: {},
  [ChainId.DOGECHAIN_TESTNET]: {},
  [ChainId.ETHEREUM_CLASSIC]: {},
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: {},
  [ChainId.FUSION]: {},
  [ChainId.FUSION_TESTNET]: {},
  [ChainId.HECO]: {},
  [ChainId.HECO_TESTNET]: {},
  [ChainId.KCC]: {},
  [ChainId.KCC_TESTNET]: {},
  [ChainId.KLAYTN]: {},
  [ChainId.KLAYTN_BAOBAB]: {},
  [ChainId.OKXCHAIN]: {},
  [ChainId.OKXCHAIN_TESTNET]: {},
  [ChainId.THETHA]: {},
  [ChainId.THETHA_TESTNET]: {},
  [ChainId.ULTRON]: {},
  [ChainId.ULTRON_TESTNET]: {},
  [ChainId.MOONBEAM]: {},
  [ChainId.MOONRIVER]: {},
  [ChainId.MOONBASE_ALPHA]: {},
  [ChainId.AURORA]: {},
  [ChainId.AURORA_TESTNET]: {},
  [ChainId.BOBA]: {},
  [ChainId.BOBA_GOERLI]: {},
  [ChainId.GNOSIS]: {},
  [ChainId.GNOSIS_CHIADO]: {},
  [ChainId.METIS]: {},
  [ChainId.METIS_GOERLI]: {},
  [ChainId.TELOS]: {},
  [ChainId.TELOS_TESTNET]: {},
  [ChainId.SYSCOIN]: {},
  [ChainId.SYSCOIN_TANENBAUM]: {},
  [ChainId.IOTEX]: {},
  [ChainId.IOTEX_TESTNET]: {},
  [ChainId.SHIDEN]: {},
  [ChainId.ASTAR]: {},
  [ChainId.SHIBUNYA]: {},
  [ChainId.FUSE]: {},
  [ChainId.FUSE_SPARKNET]: {},
  [ChainId.VELAS]: {},
  [ChainId.VELAS_TESTNET]: {},
  [ChainId.REI]: {},
  [ChainId.REI_TESTNET]: {},
  [ChainId.KEKCHAIN]: {},
  [ChainId.KEKCHAIN_TESTNET]: {},
  [ChainId.TOMOCHAIN]: {},
  [ChainId.TOMOCHAIN_TESTNET]: {},
  [ChainId.THUNDERCORE]: {},
  [ChainId.THUNDERCORE_TESTNET]: {},
  [ChainId.WANCHAIN]: {},
  [ChainId.WANCHAIN_TESTNET]: {},
  [ChainId.RSK]: {},
  [ChainId.RSK_TESTNET]: {},
  [ChainId.ELASTOS]: {},
  [ChainId.ELASTOS_TESTNET]: {},
  [ChainId.CONFLUX]: {},
  [ChainId.CONFLUX_TESTNET]: {},
  [ChainId.BRISECHAIN]: {},
  [ChainId.BRISECHAIN_TESTNET]: {},
  [ChainId.MUUCHAIN]: {},
  [ChainId.MUUCHAIN_TESTNET]: {},
  [ChainId.CANTO]: {},
  [ChainId.CANTO_TESTNET]: {},
  [ChainId.OASIS_EMERALD]: {},
  [ChainId.OASIS_TESTNET]: {},
  [ChainId.VISION]: {},
  [ChainId.VISION_TESTNET]: {},
  [ChainId.STEP]: {},
  [ChainId.STEP_TESTNET]: {},
  [ChainId.METER]: {},
  [ChainId.METER_TESTNET]: {},
  [ChainId.GODWOKEN]: {},
  [ChainId.GODWOKEN_TESTNET]: {},
  [ChainId.CALLISTO]: {},
  [ChainId.CALLISTO_TESTNET]: {},
  [ChainId.EVMOS]: {},
  [ChainId.EVMOS_TESTNET]: {},
  [ChainId.ENERGY_WEB_CHAIN]: {},
  [ChainId.ENERGY_VOLTA]: {},
  [ChainId.BASE]: {},
  [ChainId.BASE_GOERLI]: {},
  [ChainId.KAVA]: {},
  [ChainId.KAVA_TESTNET]: {},
  [ChainId.CLOVER]: {},
  [ChainId.CLOVER_TESTNET]: {},
  [ChainId.DEFICHAIN]: {},
  [ChainId.DEFICHAIN_TESTNET]: {},
  [ChainId.BRONOS]: {},
  [ChainId.BRONOS_TESTNET]: {},
  [ChainId.FILECOIN]: {},
  [ChainId.FILECOIN_CALIBRATION]: {},
  [ChainId.FLARE]: {},
  [ChainId.FLARE_TESTNET]: {},
  [ChainId.TARAXA]: {},
  [ChainId.TARAXA_TESTNET]: {},
  [ChainId.ZKSYNC]: {},
  [ChainId.ZKSYNC_TESTNET]: {},
  [ChainId.LINEA_TESTNET]: {},
}
